import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { ModelChips } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import HomologacaoIntegracao              from '../../../models/HomologacaoIntegracao';
import HomologacaoIntegracaoTipoEnum      from '../../../enums/HomologacaoIntegracaoTipoEnum';
import HomologacaoIntegracaoCampoConsultaEnum from '../../../enums/HomologacaoIntegracaoCampoConsultaEnum';
import HomologacaoIntegracaoObrigatoriedadeUrlEnum        from '../../../enums/HomologacaoIntegracaoObrigatoriedadeUrlEnum';
import HomologacaoIntegracaoObrigatoriedadeCredencialEnum from '../../../enums/HomologacaoIntegracaoObrigatoriedadeCredencialEnum';
import HomologacaoIntegracaoObrigatoriedadeSecretEnum     from '../../../enums/HomologacaoIntegracaoObrigatoriedadeSecretEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    descricao: {
        exibir:    'main.homologacaointegracao.descricao',
        visivel:   true,
        validacao: { obrigatorio: true },
    },
    tipo: {
        exibir:    'main.homologacaointegracao.tipo',
        visivel:   true,
        tipo:      'enum',
        entidade:  'integracao.tipo',
        validacao: { obrigatorio: true },
    },
    homologadoem: {
        exibir:  'main.homologacaointegracao.homologadoem',
        visivel: true,
        tipo:    'date',
    },
    campoconsulta: {
        exibir:    'main.homologacaointegracao.campoconsulta',
        tipo:      'enum',
        entidade:  'integracao.campoconsulta',
        validacao: { obrigatorio: true },
    },
    templaterequisicao: {
        exibir:    'main.homologacaointegracao.templaterequisicao',
        validacao: { obrigatorio: true },
    },
    nomecabecalhosecret: {
        exibir:    'main.homologacaointegracao.nomecabecalhosecret',
        validacao: { obrigatorio: true },
    },
    obrigatoriedadeurl: {
        exibir:    'main.homologacaointegracao.obrigatoriedadeurl',
        tipo:      'enum',
        entidade:  'integracao.obrigatoriedadeurl',
        validacao: { obrigatorio: true },
    },
    obrigatoriedadecredencial: {
        exibir:    'main.homologacaointegracao.obrigatoriedadecredencial',
        tipo:      'enum',
        entidade:  'integracao.obrigatoriedadecredencial',
        validacao: { obrigatorio: true },
    },
    obrigatoriedadesecret: {
        exibir:    'main.homologacaointegracao.obrigatoriedadesecret',
        tipo:      'enum',
        entidade:  'integracao.obrigatoriedadesecret',
        validacao: { obrigatorio: true },
    },
    caminhonome: {
        exibir:    'main.homologacaointegracao.caminhonome',
        validacao: { obrigatorio: true },
    },
    caminhocpf: {
        exibir: 'main.homologacaointegracao.caminhocpf',
    },
    caminhodatanascimento: {
        exibir: 'main.homologacaointegracao.caminhodatanascimento',
    },
    caminhocidade: {
        exibir: 'main.homologacaointegracao.caminhocidade',
    },
    caminhoemails: {
        exibir: 'main.homologacaointegracao.caminhoemails',
    },
    caminhocampoemail: {
        exibir: 'main.homologacaointegracao.caminhocampoemail',
    },
    caminhotelefones: {
        exibir: 'main.homologacaointegracao.caminhotelefones',
    },
    caminhocampoddd: {
        exibir: 'main.homologacaointegracao.caminhocampoddd',
    },
    caminhocampotelefone: {
        exibir: 'main.homologacaointegracao.caminhocampotelefone',
    },
    caminhocontratos: {
        exibir:    'main.homologacaointegracao.caminhocontratos',
        validacao: { obrigatorio: true },
    },
    caminhonumerocontrato: {
        exibir:    'main.homologacaointegracao.caminhonumerocontrato',
        validacao: { obrigatorio: true },
    },
    caminhosituacao: {
        exibir:    'main.homologacaointegracao.caminhosituacao',
        validacao: { obrigatorio: true },
    },
    caminhodescricaosituacao: {
        exibir: 'main.homologacaointegracao.caminhodescricaosituacao',
    },
    caminhologradouro: {
        exibir: 'main.homologacaointegracao.caminhologradouro',
    },
    caminhonumeroendereco: {
        exibir: 'main.homologacaointegracao.caminhonumeroendereco',
    },
    caminhobairro: {
        exibir: 'main.homologacaointegracao.caminhobairro',
    },
    situacoespermitidas: {
        exibir:    'main.homologacaointegracao.situacoespermitidas',
        tipo:      'json',
        validacao: { obrigatorio: true },
    },
    caminhopacotes: {
        exibir:    'main.homologacaointegracao.caminhopacotes',
        validacao: { obrigatorio: true },
    },
    caminhocodigopacote: {
        exibir:    'main.homologacaointegracao.caminhocodigopacote',
        validacao: { obrigatorio: true },
    },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    'integracao.tipo':          HomologacaoIntegracaoTipoEnum,
    'integracao.campoconsulta': HomologacaoIntegracaoCampoConsultaEnum,
    'integracao.obrigatoriedadeurl':        HomologacaoIntegracaoObrigatoriedadeUrlEnum,
    'integracao.obrigatoriedadecredencial': HomologacaoIntegracaoObrigatoriedadeCredencialEnum,
    'integracao.obrigatoriedadesecret':     HomologacaoIntegracaoObrigatoriedadeSecretEnum,
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class HomologacaoIntegracaoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.homologacaointegracao.aba.basica')} leftIcon="pi pi-home mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.descricao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown model={model.tipo} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelCalendar model={model.homologadoem} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.homologacaointegracao.aba.requisicao')} leftIcon="pi pi-send mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown model={model.campoconsulta} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.nomecabecalhosecret} contexto={contexto} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.templaterequisicao} contexto={contexto} rows={6} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.obrigatoriedadeurl} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.obrigatoriedadecredencial} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.obrigatoriedadesecret} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.homologacaointegracao.aba.mapeamento')} leftIcon="pi pi-sitemap mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhonome} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhocpf} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhodatanascimento} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhocidade} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhoemails} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhocampoemail} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhotelefones} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhocampoddd} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhocampotelefone} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.homologacaointegracao.aba.contratos')} leftIcon="pi pi-briefcase mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.caminhocontratos} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.caminhonumerocontrato} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.caminhosituacao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.caminhodescricaosituacao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-8 mt-3">
                            <ModelChips model={model.situacoespermitidas} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhologradouro} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhonumeroendereco} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.caminhobairro} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.caminhopacotes} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.caminhocodigopacote} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
            </TabViewComErro>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class HomologacaoIntegracaoTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={HomologacaoIntegracao}
                model={model}
                identidade="main.homologacaointegracao"
                permissoes={this.props.permissoes}
                icone="pi-link"
                storageKey="dt-homologacaointegracoes"
                ocultarColunaPublicacao // catalogo global (naofiltrarpublicacao:true no model backend)
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <HomologacaoIntegracaoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default HomologacaoIntegracaoTemplate;
